const FRAME_HEADER_BYTES = 4;
const FRAME_CRC_BYTES = 2;
const XING_TAG_BYTES = 4;

// Where an encoder-written first frame carries its "Xing"/"Info" tag, as an absolute offset into `bytes`, or null when the frame at `frameOffset` is a plain audio frame. The tag sits after the side info; LAME places it right after the header even in CRC-protected frames while other encoders move it past the CRC, so both positions are checked
export const getMp3InfoTagOffset = (
  bytes: Uint8Array,
  frameOffset: number,
  header: { sideInfoBytes: number; hasCrc: boolean }
): number | null => {
  const baseTagOffset = frameOffset + FRAME_HEADER_BYTES + header.sideInfoBytes;
  const tagOffsets =
    header.hasCrc ?
      [baseTagOffset, baseTagOffset + FRAME_CRC_BYTES]
    : [baseTagOffset];
  const infoTagOffset = tagOffsets.find((tagOffset) => {
    const tag = String.fromCharCode(
      ...bytes.subarray(tagOffset, tagOffset + XING_TAG_BYTES)
    );
    return tag === "Xing" || tag === "Info";
  });
  return infoTagOffset ?? null;
};
